<script setup>
import { useI18n } from 'vue-i18n'
import { Link } from '@inertiajs/vue3'
import RentalStatusPill from '@/Components/UI/RentalStatusPill.vue'
import { useCurrency } from '@/composables/useCurrency'

const { t } = useI18n()
const { formatDate } = useCurrency()

defineProps({
  rentals: { type: Array, default: () => [] }
})
</script>

<template>
  <section class="rounded-[var(--radius-lg)] border border-[color:var(--line)] p-3">
    <h3 class="text-xs font-semibold uppercase tracking-wider text-[color:var(--muted)] mb-2">
      {{ t('inbox.drawer.recentRentals') }}
    </h3>
    <div
      v-if="rentals.length === 0"
      class="text-xs text-[color:var(--muted)]"
    >
      {{ t('inbox.drawer.noRecentRentals') }}
    </div>
    <ul
      v-else
      class="space-y-2"
    >
      <li
        v-for="r in rentals"
        :key="r.id"
      >
        <Link
          :href="`/rentals/${r.id}`"
          class="flex items-start justify-between gap-2 text-xs hover:bg-[color:var(--surfaceAlt)] rounded p-1 -mx-1"
        >
          <div class="min-w-0">
            <div class="truncate text-[color:var(--ink)]">
              {{ r.vehicle_label || '—' }}
            </div>
            <div class="text-[color:var(--muted)]">
              {{ formatDate(r.start_at) }}
            </div>
          </div>
          <RentalStatusPill :status="r.status" />
        </Link>
      </li>
    </ul>
  </section>
</template>
